<template>
  <v-app class="scrollbar-hidden" v-if="!viewRequiresAuth()">
    <router-view></router-view>
  </v-app>

  <v-app class="scrollbar-hidden" v-else>
    <v-navigation-drawer 
      floating 
      :width="240" 
      dark 
      app 
      class="rounded-0 sidebar"
      v-model="sidebarVisible"
      :rail="!$store.state.sidebar.open"
      :expand-on-hover="!$store.state.sidebar.open"
      @mouseenter="handleDrawerHover(true)"
      @mouseleave="handleDrawerHover(false)"
    >
      <Sidebar :is-expanded-by-hover="isExpandedByHover"></Sidebar>
    </v-navigation-drawer>
    

    <v-app-bar class="elevation-0" dense app>
      <Header></Header>
    </v-app-bar>
    
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/Header.vue";
import Sidebar from "@/components/Sidebar.vue";
export default {
  name: "App",
  components: { Header, Sidebar },
  data() {
    return {
      isExpandedByHover: false
    }
  },
  computed: {
    sidebarVisible: {
      get() {
        if (this.$vuetify.display.mobile) {
          return this.$store.state.sidebar.drawer;
        }
        return true; // En desktop siempre visible, pero puede estar contraído con rail
      },
      set(value) {
        if (this.$vuetify.display.mobile) {
          this.$store.commit("setOpenSidebar", { drawer: value });
        }
      }
    },
    isRailMode() {
      return !this.$store.state.sidebar.open;
    }
  },
  created() {
    document.title = "Yegoo - Tu Producto, Donde Sea";
  },
  mounted() {
    window.document.title = "Yegoo - Tu Producto, Donde Sea";
  },
  methods: {
    viewRequiresAuth() {
      return this.$route.matched.some((record) => record.meta.requiresAuth);
    },
    handleDrawerHover(isHovering) {
      // Solo actualizar hover state cuando está en modo rail
      if (this.isRailMode) {
        this.isExpandedByHover = isHovering;
      }
    }
  },
};
</script>
